import { TreeContext } from "pages/Editor";
import { cloneElement, useContext, useMemo, useRef, useState } from "react";
import RefBroadcaster from "./RefBroadcaster";
import _ from "lodash";
import DragEdge from "./DragEdge";
import DragCorner from "./DragCorner";
import { useStyle } from "lib/hooks";
import { rootNamespace } from "config";

function getWidth(style, ref) {
  return style.width || ref.current.offsetWidth;
}

function getHeight(style, ref) {
  return style.height || ref.current.offsetHeight;
}

function wrapperStyle(ref) {
  return {
    top: 0,
    width: ref.current.style.width || ref.current.offsetWidth,
    height: ref.current.style.height || ref.current.offsetHeight,
  };
}

function edgeStyle(ref, style, vertical) {
  if (vertical) {
    return {
      top: getHeight(style, ref) - 2,
      width: getWidth(style, ref) - 2,
    };
  }
  return {
    left: getWidth(style, ref) - 2,
    height: getHeight(style, ref) - 2,
  };
}

function cornerStyle(ref, style) {
  return {
    top: getHeight(style, ref) - 2,
    left: getWidth(style, ref) - 2,
  };
}

/**
 * replacement for dragcontainer
 * has absolute handles & outlines
 * which shouldn't cause layout interference in preview or editor mode
 *
 * @param {object} props
 * @returns
 */
export default function DragWrapper({ path, children }) {
  const ref = useRef();
  const ol = useRef();
  const [, dragging] = useState(false);
  const { editable, selection, tree, publish, context, ...treeProps } =
    useContext(TreeContext);
  const [, onResize] = useStyle(["width", "height"], false);
  const component = _.get(tree, "body." + path);
  const selected = _.get(selection, "path") === path;
  function onClick(e) {
    if (e.ctrlKey || e.metaKey) {
      e.ctrlKey = false;
      e.metaKey = false;
    } else {
      e.stopPropagation();
      publish(rootNamespace, "SELECT", path);
    }
  }
  const style = useMemo(() => {
    return _.get(tree, ["body", path, "style"].join("."), {});
  }, [tree, path]);
  const props = {
    ref,
    style,
  };
  if (context === "preview") {
    props.onClick = onClick;
  }
  // console.log(selection, path)
  return (
    <TreeContext.Provider
      value={{
        ...treeProps,
        editable,
        selection,
        tree,
        publish,
        path,
        component,
        context,
      }}
    >
      {cloneElement(children, props)}
      {editable && <RefBroadcaster path={path} ref={ref} />}
      {selected && editable && (
        <>
          <div className="ol" ref={ol} style={wrapperStyle(ref, style)} />
          <DragEdge {...{ onResize, dragging, parent: [ref, ol] }} vertical>
            <div className="wx-eh v b" style={edgeStyle(ref, style, true)} />
          </DragEdge>
          <DragEdge {...{ onResize, dragging, parent: [ref, ol] }}>
            <div className="wx-eh h r" style={edgeStyle(ref, style)} />
          </DragEdge>
          <DragCorner {...{ onResize, dragging, parent: [ref, ol] }}>
            <div className="wx-ch br" style={cornerStyle(ref, style)} />
          </DragCorner>
        </>
      )}
    </TreeContext.Provider>
  );
}
